import { type PromoValue } from './getPromoForOverlay';
import { getPromoNudge } from './getPromoNudge';
export const shippingNudge = 'Spend $70 on your plan to get free shipping';

export const getSpendMoreNudge = (
  subtotal: number,
  shipping?: number,
  promo?: PromoValue,
  showOnlyShippingNudge?: boolean
) => {
  if (shipping) {
    return shippingNudge;
  } else if (promo && promo?.threshold > subtotal && !showOnlyShippingNudge) {
    return getPromoNudge(promo);
  }
};
